import { render, staticRenderFns } from "./TratamientoAdicionales.vue?vue&type=template&id=78d7a3fe&scoped=true"
import script from "./TratamientoAdicionales.vue?vue&type=script&lang=js"
export * from "./TratamientoAdicionales.vue?vue&type=script&lang=js"
import style0 from "./TratamientoAdicionales.vue?vue&type=style&index=0&id=78d7a3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7a3fe",
  null
  
)

export default component.exports